import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface ICreateTagByAdminPayload extends ISagaCb {
    data: any
}

export interface ICreateTagByAdminState {
    status: string
    data: any
    errors: any
}

const initialState: ICreateTagByAdminState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const createTagByAdmin = createSlice({
    name: 'tag/create-by-admin',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ICreateTagByAdminPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const createTagByAdminActions = createTagByAdmin.actions
export default createTagByAdmin.reducer
